export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  B03Year: 'Tổng hợp dự toán chi năm',
  ViewReport: 'Xem báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  ChinhLyQuyetToan: 'In tháng chỉnh lý quyết toán',
  BaoGomChinhLyQuyetToan: 'Bao gồm chứng từ chỉnh lý quyết toán',
  ReportForm: 'Mẫu báo cáo',
  TT344: 'Thông tư 344/2016/TT-BTC',
  LuyKe: 'Mẫu hiển thị số lũy kế đầu năm',
  Source: 'Nguồn',
  BudgetSourceCodeSUM: '##SUMMARY##',
  BudgetSourceCodeSUMVi: '<<Tổng hợp>>',
  BudgetSourceNameSUM: 'Tổng hợp',
  BudgetSourceCodeALLVi: '<<Tất cả>>',
  BudgetSourceCodeALL: '##ALL##',
  BudgetSourceNameALL: 'Tất cả',
  Chapter800: 'In chương 800',
  GetData: 'Lấy dữ liệu',
  Construction: 'Công trình',
  Quantity: 'Khối lượng năm trước thanh toán trong năm',
  M02_Title: 'Tham số báo cáo',
  M02_ChoosePeriod: 'Chọn kỳ báo cáo',
  M02_FromDate: 'Từ ngày',
  M02_ToDate: 'Đến ngày',
  M02_Source: 'Nguồn',
  M02_BudgetChapter: 'Chương',
  M02_BudgetKindItem: 'Khoản',
  M02_All: 'Tất cả',
  M02_Summary: 'Tổng hợp',
  M02_Option: 'Tùy chọn',
  M02_IncludeAdjustBudget: 'Cộng điều chỉnh kinh phí',
  M02_ExclueXDCB: 'Không lấy số liệu XDCB',
  M02_PrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
  M02_AfterWithQuater: 'Trang sau hạ thấp 1/4 trang',
  M02_IncludeAdjustVoucher: 'Bao gồm chứng từ chỉnh lý quyết toán',
  M02_OnlyTempNumber: 'Chỉ hiển thị số tạm ứng vào mục tạm ứng',
  M02_SelfTemplate: 'Mẫu tự chủ',
  M02_DisplayCompanyBy: 'Hiển thị thông tin đơn vị theo',
  M02_TemplateType: 'Mẫu báo cáo',
  M02_LocationNBudgetCode: 'Tỉnh, Huyện, Xã, Mã ĐVQHNS',
  M02_ChapterOrgBudgetCode: 'Mã chương, Đơn vị, Mã ĐVQHNS, Mã cấp NS',
  M02_TemplateQD4377: 'Quyết định số 4377/QĐ-KBNN',
  M02_TemplateTT61: 'Thông tư 61/2014/TT-BTC',
  M02_TemplateQD4377Custom: 'Quyết định số 4377/QĐ-KBNN (Mẫu tùy chỉnh)',
  M02_templateTT61Custom: 'Thông tư 61/2014/TT-BTC (Mẫu tùy chỉnh)',
  projectNameTootip: 'Công trình. Hạng mục công trình',
  showSignKBNN: 'Hiển thị chữ ký xác nhận của bên KBNN',
  NotContainAdditionBudget: 'Không bao gồm dự toán bổ sung',
  B02a: {
    Decree: 'Nghị định 11/2020/NĐ-CP',
    DecreeCustom: 'Nghị định 11/2020/NĐ-CP (Mẫu tùy chỉnh)',
    Circulars: 'Thông tư 18/2020/TT-BTC',
    CircularsCustom: 'Thông tư 18/2020/TT-BTC (Mẫu tùy chỉnh)',
    BudgetSourceAllCode: '<<Tất cả>>',
    BudgetSourceNameALL: 'Tất cả',
    BudgetSourceCodeSUM: '##SUMMARY##',
    BudgetSourceCodeALL: '##ALL##',
    DisplayCompanyBy: 'Hiển thị thông tin đơn vị theo:',
    GetFromSetFormula: 'Lấy số liệu theo công thức thiết lập báo cáo tài chính',
  },
  TT3422016_B60: {
    GroupLabelUnit: 'Đơn vị tính',
    One: 'Đồng',
    OneMillion: 'Triệu đồng',
  },
  ConfirmViewReport: 'Đồng ý',
};
